---
title: "Angewandte Organisationsentwicklung (Teil 4): Supermarktkette"
slug: "angewandte-organisationsentwicklung-teil-4-supermarktkette"
date: "2025-03-20"
excerpt: "In Teil 4 meiner Serie über angewandte Organisationsentwicklung betrachte ich eine große genossenschaftliche Supermarktkette und zeige hieran exemplarisch, wie sich Umstände und Ambitionen auf ideale Prozesse und Organisation durchschlagen."
metaTitle: "Organisationsentwicklung Teil 4: Supermarktkette | Kevin Rassner"
metaDescription: "Teil 4 der Serie über angewandte Organisationsentwicklung: Analyse einer großen genossenschaftlichen Supermarktkette und deren Prozess- und Organisationsdesign."
language: "de"
author: "Kevin Rassner"
authorUrl: "https://rassner-dev.org"
linkedinUrl: "https://www.linkedin.com/feed/update/urn:li:activity:7308458603235999747"
isLinkedInPost: true
tags: ["Organisationsentwicklung", "sowaswie", "edeka"]
---

In Teil 4 meiner Serie über angewandte Organisationsentwicklung betrachte ich eine große genossenschaftliche Supermarktkette und zeige hieran exemplarisch, wie sich Umstände und Ambitionen auf ideale Prozesse und Organisation durchschlagen. Teilt mir eure Meinungen zu diesem Case mit oder schickt mir eure Wünsche, welches Unternehmen ich als nächstes betrachten soll.

